{
  "id": "campaign-112",
  "name": "Fine Court",
  "seed": "campaign:112",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "......CCCCCC......",
    "......UCCCCU......",
    "....CCCCCCCCCC....",
    "...XC.,......CX...",
    "....C,,t..t..C....",
    "....C.,......C....",
    "....C.t....t.C....",
    ".B..C...ww..,C,.B.",
    "....C.B~ww.B.C....",
    "..t,Ct~~~...tC.t..",
    "...,C..~.....C....",
    "...,C........C....",
    "....C..t..t..C....",
    "....C.,,,....C...x",
    "....CCCCCCCCCC....",
    "..x............x..",
    ".................S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 2,
      "y": 2
    },
    {
      "kind": "rabbit",
      "x": 4,
      "y": 16
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 6
    },
    {
      "kind": "squirrel",
      "x": 10,
      "y": 10
    },
    {
      "kind": "rabbit",
      "x": 1,
      "y": 6
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 5,
      "y": 4
    },
    {
      "kind": "gas",
      "x": 16,
      "y": 15
    },
    {
      "kind": "gas",
      "x": 1,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 15
    },
    {
      "kind": "rare",
      "x": 7,
      "y": 14
    },
    {
      "kind": "repair",
      "x": 17,
      "y": 1
    }
  ],
  "falls": [
    {
      "x": 14,
      "y": 3,
      "dir": "S",
      "at": 38,
      "length": 3
    },
    {
      "x": 3,
      "y": 3,
      "dir": "S",
      "at": 44,
      "length": 3
    }
  ],
  "generatorVersion": 3,
  "level": 112,
  "biome": "estate",
  "par": {
    "reel": 8226,
    "push": 7234,
    "selfPropelled": 6672,
    "tractor": 5460,
    "zeroTurn": 4871,
    "fairway": 3244
  },
  "goldTime": {
    "reel": 8226,
    "push": 7234,
    "selfPropelled": 6672,
    "tractor": 5460,
    "zeroTurn": 4803,
    "fairway": 3057
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 7,
      "zeroTurn": 0,
      "fairway": 6
    },
    "gold": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 7,
      "zeroTurn": 34,
      "fairway": 45
    }
  }
}
